/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../store";

interface IState {
  favorites: any
  trackedItems: any
  isLoadingTrackedItems: boolean
}

const initialState: IState = {
  favorites: {},
  trackedItems: {},
  isLoadingTrackedItems: false
} as IState

const slice = createSlice({
  name: 'favoritesSlice',
  initialState,
  reducers: {
    setFavorites: (state, action: PayloadAction<any>) => void (state.favorites = action.payload),
    setTrackedItems: (state, action: PayloadAction<any>) => void (state.trackedItems = action.payload),
    setIsLoadingTrackedItems: (state, action: PayloadAction<boolean>) => void (state.isLoadingTrackedItems = action.payload)
  }
})

const selectFavoritesState = (state: RootState): IState => state.favorites
const selectFavorites = (state: RootState) => selectFavoritesState(state).favorites
const selectTrackedItems = (state: RootState) => selectFavoritesState(state).trackedItems
const selectIsLoadingTrackedItems = (state: RootState) => selectFavoritesState(state).isLoadingTrackedItems

const {actions, reducer} = slice
export {
  selectFavoritesState,
  selectFavorites,
  selectTrackedItems,
  selectIsLoadingTrackedItems
}
export const {
  setFavorites,
  setTrackedItems,
  setIsLoadingTrackedItems
} = actions

export default reducer
